import React, {Component} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {Thead, Tbody, HistoryButton} from './history';
import {getHistory, sendHistory} from './../actions/historyActions';
import {connect} from 'react-redux';
import Alert from './Alert/Alert';
import {hideAlert} from './../actions/AlertActions';
import IndicatorLoading from './indicatorLoading/IndicatorLoading';
import T from 'i18n-react';

const mes= {
    type:'error',
    text: 'You successfully'
}

class HistoryPage extends Component {
  constructor (props){
    super(props);
  }

  closeMessage = () => {
    this.props.hideAlert();
  }

  componentDidMount(){
    this.props.getHistory(this.props.accountId);
  }

  sendHistoryClick = () => {
    this.props.sendHistory(this.props.accountId);
  }

  back = () => {
    this.props.history.push('/welcome');
  }

    render() {
        const {accountId, messageAlert, typeMessage, visible, isFatchingHistory
          ,showIndicator} = this.props;

        const message= {
            type: typeMessage,
            text: messageAlert
        }
        return (
        <div className="col col-sm-10 col-md-8">
          <h4 className="title-screen">
            <T.text tag='span' text="trn_history"/>
          </h4>

         <div className = "t-scroll">
           { showIndicator &&
             <IndicatorLoading/>
           }
           { !showIndicator && <table className="table table-bordered">
                <Thead />
                <Tbody list = {this.props.list} />
            </table>}
         </div>

         <ReactCSSTransitionGroup
                transitionName="appear"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={500}>
             {visible == true && <Alert onClose={this.closeMessage} message={message} timeout={2000} />   }
         </ReactCSSTransitionGroup>

        <HistoryButton onClick={this.sendHistoryClick}
            onClickBack={this.back}
            disabled = {isFatchingHistory} />

        </div>
    );
    }
}
export default connect(
    (state) => {
        return {
            accountId: state.authReducer.accountId,
            list: state.history.list,
            visible: state.alert.visible,
            messageAlert: state.alert.message,
            typeMessage: state.alert.type,
            isFatchingHistory: state.history.isFatchingHistory,
            showIndicator: state.authReducer.showIndicator
        }
    },
    {getHistory, sendHistory, hideAlert}
)(HistoryPage);



// WEBPACK FOOTER //
// ./src/components/HistoryPage.js